import { render } from "./ResetPasswordFrontForm.vue?vue&type=template&id=2afd04fb&ts=true&lang=pug"
import script from "./ResetPasswordFrontForm.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordFrontForm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/ResetPasswordFrontForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2afd04fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2afd04fb', __exports__)) {
    console.log('reload')
    api.reload('2afd04fb', __exports__)
  }
  
  module.hot.accept("./ResetPasswordFrontForm.vue?vue&type=template&id=2afd04fb&ts=true&lang=pug", () => {
    console.log('re-render')
    api.rerender('2afd04fb', render)
  })

}


export default __exports__